export function setupSuggestionsUI(
    app,
    postType,
    bodyScrollLocks,
    setBodyScrollLock,
    buildSearchUrl
) {
    if (!app.classList.contains('type-suggestions')) return;

    const searchBoxContainer = app.querySelector('.snaf-searchbox');
    const searchBoxWrapper = app.querySelector('.snaf-searchbox-wrapper') || searchBoxContainer;
    const modalHeader = app.querySelector('.snaf-modal-header');
    const dropdown = app.querySelector('.snaf-suggestions-dropdown');
    const backdrop = app.querySelector('.snaf-suggestions-backdrop');
    const closeBtn = app.querySelector('.snaf-suggestions-close');
    const viewAllLink = app.querySelector('.snaf-view-all-btn');

    if (!searchBoxContainer || !dropdown) return;

    let isFullMode = false;
    let originalSearchBoxParent = searchBoxWrapper.parentElement;
    let originalSearchBoxNextSibling = searchBoxWrapper.nextSibling;

    const expandToFullMode = () => {
        if (isFullMode) return;
        isFullMode = true;
        dropdown.classList.add('is-full-mode');
        setBodyScrollLock(`fullmode:${postType}`, true);

        // Move searchbox into the modal header seamlessly
        if (modalHeader && searchBoxWrapper.parentElement !== modalHeader) {
            // We insert it before the close button in the header
            modalHeader.insertBefore(searchBoxWrapper, closeBtn);
        }

        const input = searchBoxContainer.querySelector('.ais-SearchBox-input');
        if (input) {
            input.focus();
            const valLen = input.value.length;
            input.setSelectionRange(valLen, valLen);
        }
    };

    const collapseFromFullMode = () => {
        if (!isFullMode) return;
        isFullMode = false;
        dropdown.classList.remove('is-full-mode');
        setBodyScrollLock(`fullmode:${postType}`, false);

        // Move searchbox back to its original position
        if (originalSearchBoxParent && searchBoxWrapper.parentElement !== originalSearchBoxParent) {
            originalSearchBoxParent.insertBefore(searchBoxWrapper, originalSearchBoxNextSibling);
        }
    };

    const positionDropdown = () => {
        if (isFullMode) return;
        const rect = searchBoxContainer.getBoundingClientRect();
        // Since dropdown is position: fixed, top is relative to viewport
        dropdown.style.top = rect.bottom + 5 + 'px';
    };

    const openDropdown = () => {
        const input = searchBoxContainer.querySelector('.ais-SearchBox-input');
        if (input && input.value.trim().length > 0) {
            dropdown.classList.add('is-open');
            app.classList.add('snaf-suggestions-open');
            if (backdrop) backdrop.classList.add('is-visible');
            setBodyScrollLock(`suggestions:${postType}`, true);

            if (window.innerWidth <= 860) {
                expandToFullMode();
            } else {
                positionDropdown();
            }
        }
    };

    const closeDropdown = () => {
        if (isFullMode) collapseFromFullMode();
        dropdown.classList.remove('is-open');
        app.classList.remove('snaf-suggestions-open');
        if (backdrop) backdrop.classList.remove('is-visible');
        setBodyScrollLock(`suggestions:${postType}`, false);

        // Clear the input natively
        const inputs = app.querySelectorAll('.ais-SearchBox-input');
        inputs.forEach((input) => {
            if (input.value !== '') {
                input.value = '';
                input.dispatchEvent(new Event('input', { bubbles: true }));
            }
        });
    };

    // Show dropdown on focus if there's text
    searchBoxContainer.addEventListener('focusin', (e) => {
        if (e.target.classList.contains('ais-SearchBox-input')) {
            openDropdown();
        }
    });

    // Update query params on type, and show/hide dropdown
    searchBoxContainer.addEventListener('input', (e) => {
        if (e.target.classList.contains('ais-SearchBox-input')) {
            const val = e.target.value.trim();
            if (viewAllLink) {
                viewAllLink.href = buildSearchUrl(val);
            }

            if (val.length > 0) {
                openDropdown();
            } else {
                closeDropdown();
            }
        }
    });

    // Redirect on Enter
    searchBoxContainer.addEventListener('keydown', (e) => {
        if (e.target.classList.contains('ais-SearchBox-input')) {
            if (e.key === 'Enter') {
                e.preventDefault();
                expandToFullMode();
            }
        }
    });

    // Close on Escape from anywhere
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && dropdown.classList.contains('is-open')) {
            closeDropdown();
            const input = searchBoxContainer.querySelector('.ais-SearchBox-input');
            if (input && document.activeElement === input) {
                input.blur();
            }
        }
    });

    if (viewAllLink) {
        viewAllLink.addEventListener('click', (e) => {
            e.preventDefault();
            expandToFullMode();
        });
    }

    app.addEventListener(
        'click',
        (e) => {
            if (e.target.closest('.ais-InfiniteHits-loadMore') && !isFullMode) {
                e.preventDefault();
                e.stopPropagation();
                expandToFullMode();
            }
        },
        true
    );

    // Close handlers
    if (closeBtn) closeBtn.addEventListener('click', closeDropdown);
    if (backdrop) backdrop.addEventListener('click', closeDropdown);

    // Re-position on window resize
    window.addEventListener('resize', () => {
        if (dropdown.classList.contains('is-open')) {
            positionDropdown();
        }
    });
}
